export default "__VITE_ASSET__344b4cce__"